import { Translator } from 'Translator';
import { getFilter } from 'data/filters';

export type FilterOption = { id: number; value: string; name: string };
export type FilterOptions = FilterOption[];
export type FilterBlockData = {
  filterOptions: FilterOptions;
  title: string;
  uid: string;
};
export type FilterBlocks = FilterBlockData[];
export type ActiveFilter = { uid: string; options: FilterOptions };

const languageFilters: FilterOptions = getFilter(
  'languages.items[]',
).subOptions.map(({ name, id, value }) => ({
  name,
  id,
  value: decodeURIComponent(value),
}));

const familyFriendlyFilter: FilterOptions = [
  {
    id: 0,
    value: 'family-friendly',
    name: Translator.translate(
      'FamilyFriendly.label',
      {},
      true,
      'Family Friendly',
    ),
  },
];

export const filters: FilterBlocks = [
  {
    filterOptions: languageFilters,
    title: Translator.translate(
      'GuideSearch.localGuideLanguage',
      {},
      true,
      'Local guide language',
    ),
    uid: 'languages',
  },
  {
    filterOptions: familyFriendlyFilter,
    title: Translator.translate(
      'GuideSearch.otherFilters',
      {},
      true,
      'Other filters',
    ),
    uid: 'other',
  },
  {
    filterOptions: [],
    title: Translator.translate('', {}, true, 'Date from'),
    uid: 'date.from',
  },
  {
    filterOptions: [],
    title: Translator.translate('', {}, true, 'Date to'),
    uid: 'date.to',
  },
];

export const hostTypes = ['guides'];
